<template>
    <div>
        <v-form-input v-if="mode === 'phone'" :readonly="verified" field="phone" mask="phone" label="Введите телефон" v-margin.bottom="2">
            <template slot="caption" scope="props">
                <span v-if="verified">Номер подтвержден</span>
                <span v-else-if="timer">
                    Отправить код можно через {{ timer }} {{seconds}}
                </span>
                <span v-else>Мы отправим вам SMS с кодом подтверждения</span>
            </template>
        </v-form-input>
    
        <div v-if="mode === 'code'">
            <v-form-input field="code" mask="code" label="Введите sms-код" autocomplete="off" v-margin.bottom="2">
                <template slot="error" scope="props">{{ errorCode || props.error }}</template>
                <template slot="caption" scope="props">
                    <v-row>
                        <v-col xs="7" v-padding.right="0">
                            <span v-if="timer">
                                Отправить код можно через {{ timer }} {{seconds}}
                            </span>
                            <v-link v-else to="javascript:;" @click.native="handleSendCode">
                                Отправить код повторно
                            </v-link>
                        </v-col>
                        <v-col v-text-align.right v-padding.left="0">
                            <v-link to="javascript:;" @click.native="isShowModal = true">
                                Не приходит SMS?
                            </v-link>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-link to="javascript:;" @click.native="handleResetPhone">
                                Изменить номер
                            </v-link>
                        </v-col>
                    </v-row>
                </template>
            </v-form-input>
        </div>
    
        <v-green-button v-if="mode === 'phone' && !verified" type="button" primary block @click="handleSendCode" :disabled="invalidPhone || disabled  || !!timer">
            отправить код
        </v-green-button>
    
        <v-spinner v-if="mode === 'code'" block :active="loader">
            <v-green-button :disabled="invalidCode || disabled" primary block @click="handleConfirmCode">
                подтвердить
            </v-green-button>
        </v-spinner>

        <v-modal :active="isShowModal" @close="isShowModal = false">
            <div v-padding="2">
                <div>
                    <v-text type="title" v-margin.bottom="2">
                        Не приходит SMS?
                    </v-text>
                </div>

                <v-text type="subheadling">
                    Принимаем звонки ПН - ПТ, с 10:00 до 18:00 (МСК)
                </v-text>

                <div v-text-align.right>
                    <v-button primary flat @click="isShowModal = false">
                        закрыть
                    </v-button>
                </div>
            </div>
        </v-modal>
    </div>
</template>
<script>
import { declOfNum } from '../../helpers';
import { vButton } from './baseComponents';

export default {
    name: 'form-phone-verify',
    props: {
        errorCode: String,
        timer: Number,
        mode: {
            type: String,
            default: 'phone',
        },
        invalidPhone: Boolean,
        invalidCode: Boolean,
        loader: Boolean,
        verified: Boolean,
        disabled: Boolean,
    },
    components: {
        vGreenButton: vButton,
    },
    data() {
        return {
            isShowModal: false,
        }
    },
    methods: {
        handleSendCode(e) {
            this.$emit('send-code');
        },
        handleConfirmCode() {
            this.$emit('confirm-code');
        },
        handleResetPhone() {
            this.$emit('reset');
        }
    },
    computed: {
        seconds() {
            return declOfNum(this.timer, [
                'секунду',
                'секунды',
                'секунд',
            ]);
        },
    }
}
</script>



// WEBPACK FOOTER //
// FormPhoneVerify.vue?e2a08014